import { Box, Typography, SxProps, Theme, Button } from '@mui/material';

const FIGMA_BUTTON_WIDTH = 212;

type HeaderCTACardProps = Readonly<{
  title: string;
  buttonText: string;
  buttonOnClick: () => void;
  imageUrl: string;
}>;

export const HeaderCTACard = ({
  title,
  buttonText,
  buttonOnClick,
  imageUrl,
}: HeaderCTACardProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={contentContainerSx}>
        <Typography sx={titleSx}>{title}</Typography>
        <Button hierarchy="Secondary gray" size="md" onClick={buttonOnClick} sx={buttonSx}>
          {buttonText}
        </Button>
      </Box>
      <Box component="img" src={imageUrl} alt="header-cta-card" sx={imageContainerSx} />
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Foreground/fg-primary'],
  borderRadius: backrs.radius['radius-xl'],
  flexWrap: 'wrap',
  flexDirection: 'column',
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-xl'],
  paddingTop: {
    xs: backrs.spacing['spacing-2xl'],
    sm: backrs.spacing['spacing-4xl'],
  },
  pl: {
    xs: backrs.spacing['spacing-2xl'],
    sm: backrs.spacing['spacing-6xl'],
  },
  pr: {
    xs: backrs.spacing['spacing-2xl'],
    sm: backrs.spacing['spacing-4xl'],
  },
});

const titleSx: SxProps<Theme> = ({ typography, backrs, breakpoints }) => ({
  color: backrs.colors['Colors/Base/White'],
  ...typography['display-md-semibold'],
  [breakpoints.down('sm')]: {
    ...typography['display-xs-semibold'],
  },
});

const buttonSx: SxProps<Theme> = {
  width: {
    sm: `${FIGMA_BUTTON_WIDTH}px`,
  },
};

const imageContainerSx: SxProps<Theme> = ({ backrs }) => ({
  px: {
    xs: backrs.spacing['spacing-2xl'],
    sm: backrs.spacing['spacing-4xl'],
    md: backrs.spacing['spacing-9xl'],
  },
  pb: backrs.spacing['spacing-2xl'],
  pt: backrs.spacing['spacing-lg'],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  margin: 'auto',
  pointerEvents: 'none',
  objectFit: 'contain',
  width: '100%',
  height: 'auto',
});
